/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Ar as Ar,
  rec_JSXRuntime as JSXRuntime,
  rec_RS as RS,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_LS_76_83(e) {
  let t = (0, ReactCompiler.c)(19),
    { titulo: n, aclaracion: r, cuenta: i, abiertaInicial: a, children: o } = e,
    s = i === void 0 ? 0 : i,
    [c, l] = (0, React.useState)(a !== void 0 && a),
    u;
  t[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((u = () => l(RS)), (t[0] = u))
    : (u = t[0]);
  let f = `h-4 w-4 shrink-0 transition duration-150 ease-(--curva) ${c ? `rotate-180` : ``}`,
    p;
  t[1] === f
    ? (p = t[2])
    : ((p = <Ar className={f} />), (t[1] = f), (t[2] = p));
  let m;
  t[3] === s
    ? (m = t[4])
    : ((m = s > 0 && (
        <span
          className={`rounded-full bg-(--panel) px-1.5 py-0.5 text-[11px] font-normal text-(--text)`}
          children={s}
        />
      )),
      (t[3] = s),
      (t[4] = m));
  let h;
  t[5] === r
    ? (h = t[6])
    : ((h = r && (
        <span
          className={`hidden font-normal text-(--text) sm:inline`}
          children={[`— `, r]}
        />
      )),
      (t[5] = r),
      (t[6] = h));
  let _;
  t[7] !== c || t[8] !== p || t[9] !== m || t[10] !== h || t[11] !== n
    ? ((_ = (
        <button
          type={`button`}
          onClick={u}
          aria-expanded={c}
          className={`flex w-full items-center gap-1.5 rounded-xl py-1 text-left text-sm font-medium text-(--text-h) transition duration-150 ease-(--curva) hover:text-(--accent) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--accent-border)`}
          children={[p, n, m, h]}
        />
      )),
      (t[7] = c),
      (t[8] = p),
      (t[9] = m),
      (t[10] = h),
      (t[11] = n),
      (t[12] = _))
    : (_ = t[12]);
  let v;
  t[13] !== c || t[14] !== o
    ? ((v = c && <div className={`animar-entrada`} children={o} />),
      (t[13] = c),
      (t[14] = o),
      (t[15] = v))
    : (v = t[15]);
  let y;
  return (
    t[16] !== _ || t[17] !== v
      ? ((y = <div children={[_, v]} />), (t[16] = _), (t[17] = v), (t[18] = y))
      : (y = t[18]),
    y
  );
}
